import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';

import { TableComponent, connect } from "../tableComponent";
import config from 'src/config'

class Component extends TableComponent {

  initialState = {
    from: moment().subtract(1, 'week'),
    to: moment().add(1, 'day')
  }

  getInitialState = (initialState)=> {
    initialState.from = moment().isoWeekday(1);
    return initialState
  }

  makeColumns = () => {
    var columns;
    var expand = this.props.state.expand || this.props.state.initial;
    if (this.props.state.initial && this.props.user.role_id >= 3) {
      expand = false;
    }
    columns = [
      {
        Header: "Id",
        accessor: "id",
        Cell: ({ original }) =>
          <div>
            <div>{original.id}</div>
          </div>,
        minWidth: 30,
        Footer: props => <span>Total</span>
      }, {
        Header: props => "Date",
        accessor: "timenow",
        minWidth: 50,
        Cell: props => 
          <div>
            <div>{moment(parseInt(props.value)).format("D MMM YYYY HH:mm")}</div>
          </div>,    
        Footer: props => <span>{this.props.total.count || 0}</span>    
      }, {
        Header: "Name1",
        accessor: "name1",
        minWidth: 50,
      }, {
        Header: "Name2",
        accessor: "name2",
        minWidth: 50 
      }, {
        Header: "Wid",
        accessor: "wid",
        minWidth: 50 
      }, {
        Header: "Subaffiliate",
        accessor: "subaffiliate",
        minWidth: 50 
      }

    ]
    return columns; 
  }

  apiPath = "fraud/find"

  tableParams = {
    manual: true,
    sorted: [{
      id: "id",
      desc: true
    }],
    showAll: false
  }

  render() {
    return (
      <div>
        {!this.props.state.initial &&         
        
        <div>   
          <div class="row table-head-controls">
            <div class="col-10">
              {false && this.datepickerElement()} 
            </div>
            <div class="col-2">{this.searchElement()}</div>
          </div>
        </div>
        }
        <div class="row">
          <div class="col-sm-12">
            <div class="box mt-2">{this.reactTable()}</div>
          </div>
        </div>
      </div> 
    );
  }
}

export default connect(Component,"fraud_find",null,null,{ withRef: true })